import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconPrescription } from '@redteclab/icons'

const paragraph = (chunks: ReactNode[]): JSX.Element => (
  <p className="mb-3">{chunks}</p>
)

export const ProductPageOdsDialogOnlineDoctorSectionBilling: FC = () => (
  <section className="mt-5" id="online-doctor-billing">
    <div className="flex">
      <div className="mr-2">
        <IconPrescription className="text-l" />
      </div>
      <div>
        <h3 className="mb-5 font-medium">
          <FormattedMessage id="pdp.buyboxwithvariants.odsModal.onlineDoctor.billingAsPrivate.heading" />
        </h3>
        <div className="text-dark-primary-max">
          <FormattedMessage
            id="pdp.buyboxwithvariants.odsModal.onlineDoctor.billingAsPrivate.description"
            values={{ paragraph }}
          />
        </div>
      </div>
    </div>
  </section>
)
